import CardService from './CardService';

export default CardService;
